import { render, staticRenderFns } from "./listPicture.vue?vue&type=template&id=d133430c&scoped=true"
import script from "./listPicture.vue?vue&type=script&lang=js"
export * from "./listPicture.vue?vue&type=script&lang=js"
import style0 from "./listPicture.vue?vue&type=style&index=0&id=d133430c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d133430c",
  null
  
)

export default component.exports